import { render, staticRenderFns } from "./DescriptionText.vue?vue&type=template&id=48601a8e&"
import script from "./DescriptionText.vue?vue&type=script&lang=js&"
export * from "./DescriptionText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports